export default "__VITE_ASSET__ZoqJ$lWj__"